<template>
  <div class="form form-invoice">
    <h5>{{ $t("message.contracts.document_ktg_attorney") }}</h5>
    <br />
    <div
      class="alert mt-2 alert-success rounded d-flex"
      v-if="ktg_attorney.IsSigned"
    >
      <span style="flex-basis: 50%">
        {{
          $t("message.contracts.signed_message_" + ktg_attorney.SignatureType)
        }}
        {{ ktg_attorney.SignDate }}<br />
        {{ ktg_attorney.SignatureName }}
      </span>
    </div>
    <div class="row">
      <div class="col-md-12">
        <h5>{{ $t("message.contracts.ktg_attorney_principal") }}</h5>
      </div>
      <div class="col-md-12">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            :readonly="is_field_readonly"
            type="text"
            class="form-control"
            v-model="ktg_attorney.ktg_principal_name"
            :placeholder="$t('message.contracts.ktg_attorney_principal_name')"
            autocomplete="off"
            style="cursor: auto"
            id="ktg_attorney_principal_name"
          />
          <label
            for="ktg_attorney_principal_name"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.ktg_attorney_principal_name") }}</label
          >
        </span>
      </div>

      <div class="col-md-12">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            :readonly="is_field_readonly"
            type="text"
            class="form-control"
            v-model="ktg_attorney.ktg_principal_reg_number"
            :placeholder="
              $t('message.contracts.ktg_attorney_principal_reg_number')
            "
            autocomplete="off"
            style="cursor: auto"
            id="ktg_attorney_principal_reg_number"
          />
          <label
            for="ktg_attorney_principal_reg_number"
            class="form-label-group-label shorter"
            >{{
              $t("message.contracts.ktg_attorney_principal_reg_number")
            }}</label
          >
        </span>
      </div>

      <div class="col-md-6">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            :readonly="is_field_readonly"
            type="text"
            class="form-control"
            v-model="ktg_attorney.ktg_principal_code"
            :placeholder="$t('message.contracts.ktg_attorney_principal_code')"
            autocomplete="off"
            style="cursor: auto"
            id="ktg_attorney_principal_code"
          />
          <label
            for="ktg_attorney_principal_code"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.ktg_attorney_principal_code") }}</label
          >
        </span>
      </div>

      <div class="col-md-6">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            :readonly="is_field_readonly"
            type="text"
            class="form-control"
            v-model="ktg_attorney.ktg_principal_address"
            :placeholder="
              $t('message.contracts.ktg_attorney_principal_address')
            "
            autocomplete="off"
            style="cursor: auto"
            id="ktg_attorney_principal_address"
          />
          <label
            for="ktg_attorney_principal_address"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.ktg_attorney_principal_address") }}</label
          >
        </span>
      </div>

      <div class="col-md-12">
        <h5>{{ $t("message.contracts.ktg_attorney_representative") }}</h5>
      </div>
      <div class="col-md-6">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            :readonly="is_field_readonly"
            type="text"
            class="form-control"
            v-model="ktg_attorney.ktg_representative_full_name"
            :placeholder="$t('message.contracts.ktg_representative_full_name')"
            autocomplete="off"
            style="cursor: auto"
            id="ktg_representative_full_name"
          />
          <label
            for="ktg_representative_full_name"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.ktg_representative_full_name") }}</label
          >
        </span>
      </div>

      <div class="col-md-6">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            :readonly="is_field_readonly"
            type="text"
            class="form-control"
            v-model="ktg_attorney.ktg_representative_job_title"
            :placeholder="$t('message.contracts.ktg_representative_job_title')"
            autocomplete="off"
            style="cursor: auto"
            id="ktg_representative_job_title"
          />
          <label
            for="ktg_representative_job_title"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.ktg_representative_job_title") }}</label
          >
        </span>
      </div>

      <div class="col-md-6">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            :readonly="is_field_readonly"
            type="text"
            class="form-control"
            v-model="ktg_attorney.ktg_acting_basis"
            :placeholder="$t('message.contracts.ktg_acting_basis')"
            autocomplete="off"
            style="cursor: auto"
            id="ktg_acting_basis"
          />
          <label
            for="ktg_acting_basis"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.ktg_acting_basis") }}</label
          >
        </span>
      </div>
      <div class="col-md-6">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            :readonly="is_field_readonly"
            type="text"
            class="form-control"
            v-model="ktg_attorney.ktg_place"
            :placeholder="$t('message.contracts.ktg_place')"
            autocomplete="off"
            style="cursor: auto"
            id="ktg_place"
          />
          <label for="ktg_place" class="form-label-group-label shorter">{{
            $t("message.contracts.ktg_place")
          }}</label>
        </span>
      </div>

      <div class="col-md-12">
        <span :class="['bmd-form-group mb-2 d-block form-label-group shorter']">
          <datepicker
            :disabled="is_field_readonly"
            value-type="YYYY-MM-DD"
            format="DD.MM.YYYY"
            @focus="ktg_attorney.ktg_attorney_issued_before = ' '"
            @blur="
              ktg_attorney.ktg_attorney_issued_before == ' '
                ? (ktg_attorney.ktg_attorney_issued_before = '')
                : (ktg_attorney.ktg_attorney_issued_before =
                    ktg_attorney.ktg_attorney_issued_before)
            "
            inputClass="form-control"
            v-model="ktg_attorney.ktg_attorney_issued_before"
            :placeholder="$t('message.contracts.ktg_attorney_issued_before')"
            :inputAttr="{ id: 'ktg_attorney_issued_before' }"
          />
          <label
            for="ktg_attorney_issued_before"
            class="form-label-group-label shorter"
            :class="
              ktg_attorney.ktg_attorney_issued_before != '' &&
              ktg_attorney.ktg_attorney_issued_before != null
                ? 'topped'
                : ''
            "
            >{{ $t("message.contracts.ktg_attorney_issued_before") }}</label
          >
        </span>
      </div>

      <div class="col-md-12">
        <h5>{{ $t("message.contracts.ktg_attorney_wagons_list") }}</h5>
      </div>

      <b-table
        responsive
        striped
        hover
        :items="ktg_attorney.wagons"
        :tbody-tr-class="rowClass"
        :fields="wagon_fields"
      >
        <template v-slot:cell(remove)="data">
          <button
            class="btn btn-sm btn-link text-info"
            @click="editWagon(data.item, data.index)"
          >
            <i class="fa fa-edit"></i></button
          ><button
            v-if="!is_field_readonly"
            class="btn btn-sm btn-link text-danger"
            @click="removeWagon(data.index)"
          >
            <i class="fa fa-times"></i>
          </button>
        </template>
      </b-table>
      <button
        v-if="!is_field_readonly"
        id="add-ktg_attorney_wagons-modal-open-button"
        class="btn btn-sm btn-round btn-pills btn-success"
        v-b-modal.modal-add-ktg_attorney_wagon
      >
        {{ $t("message.add") }}
      </button>
    </div>

    <div
      class="buttons"
      style="position: absolute; bottom: 16px; right: 20%; left: 20px"
      v-if="!is_field_readonly && !is_edit"
    >
      <button
        class="btn btn-outline-success btn-sm dropdown-toggle"
        type="button"
        id="dropdownMenuButton"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        :disabled="buttons_loading"
      >
        {{
          $t(
            is_new
              ? "message.contracts.document_create"
              : "message.contracts.document_save",
          )
        }}&nbsp;&nbsp;
        <div
          class="loading loading-button"
          v-if="loading"
          style="
            border-top-width: 2px;
            border-top-color: #4caf50;
            top: 30px;
            right: -93px;
          "
        ></div>
      </button>
      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
        <a
          class="dropdown-item"
          style="color: #4caf50"
          @click="saveDocument()"
          :disabled="buttons_loading"
          >{{
            $t(
              is_new
                ? "message.contracts.document_create"
                : "message.contracts.document_save",
            )
          }}</a
        >
        <a
          class="dropdown-item"
          style="color: #4caf50"
          v-if="!is_new"
          @click="submit_and_sign_dialog()"
          :disabled="buttons_loading"
          >{{ $t("message.contracts.submit_and_sign_button") }}</a
        >
      </div>
    </div>

    <b-modal
      id="modal-add-ktg_attorney_wagon"
      :hide-footer="true"
      size="md"
      :title="$t('message.add')"
    >
      <div class="row">
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-2 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="wagon.ktg_wagon_number"
              :placeholder="$t('message.contracts.ktg_wagon_number')"
              autocomplete="off"
              style="cursor: auto"
              id="ktg_wagon_number"
            />
            <label
              for="ktg_wagon_number"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.ktg_wagon_number") }}</label
            >
          </span>
        </div>
      </div>

      <button v-if="edit_wagon" @click="save_wagon()" class="btn btn-success">
        {{ $t("message.add") }}
      </button>
      <button
        id="add-rwb-good-button"
        v-else
        @click="add_wagon()"
        class="btn btn-success"
      >
        {{ $t("message.add") }}
      </button>
    </b-modal>

    <b-modal
      id="modal-select-ecp-type-ktg_attorney"
      :hide-footer="true"
      size="sm"
      :title="$t('message.contracts.select_ecp_type')"
    >
      <div class="text-center" v-if="!show_code_sign_type">
        <button
          class="btn btn-outline-success btn-round"
          @click="signDocument()"
        >
          {{ $t("message.contracts.sign_with_ecp") }}
        </button>
        <div>
          <small>
            <i>
              {{ $t("message.contracts.only_for_kz") }}
            </i>
          </small>
        </div>
        <hr />
        <button
          class="btn btn-outline-success btn-round"
          @click="sign_with_code()"
        >
          {{ $t("message.contracts.sign_with_code") }}
        </button>
      </div>
      <div class="text-center" v-if="show_code_sign_type">
        <div class="form-group">
          <label for="input-code">
            {{ $t("message.contracts.input_signature_code") }}
          </label>
          <input
            type="text"
            class="form-control"
            id="input-code"
            v-model="sign_with_code_code"
          />
        </div>
        <button
          class="btn btn-success btn-round"
          @click="sign_with_code_phase2()"
        >
          {{ $t("message.contracts.sign_with_code") }}
        </button>
        <hr />
        <button
          class="btn btn-default btn-round btn-sm"
          @click="show_code_sign_type = false"
        >
          {{ $t("message.cancel") }}
        </button>
      </div>
    </b-modal>
  </div>
</template>
<script>
var querystring = require("querystring");
import { required } from "vuelidate/lib/validators";
export default {
  props: [
    "goods",
    "contract_details",
    "document_id",
    "is_new",
    "document",
    "readonly",
    "is_edit",
    "files",
  ],
  name: "form-insurance",
  data() {
    return {
      buttons_loading: false,
      edit_wagon: false,
      wagon: { ktg_wagon_number: "" },
      currently_editing: 0,

      doc_id: "",
      show_code_sign_type: false,
      sign_with_code_code: "",

      ktg_attorney: {
        ktg_id: "",
        ref_doc_id: "",
        ktg_doc_date: "",
        ktg_place: "",
        ktg_principal_code: "",
        ktg_representative_job_title: "",
        ktg_acting_basis: "",
        ktg_attorney_issued_before: "",
        ktg_representative_full_name: "",
        ktg_principal_name: "",
        ktg_principal_reg_number: "",
        ktg_principal_address: "",
        wagons: [],
      },

      wagon_fields: [
        {
          key: "ktg_wagon_id",
          label: this.$t("message.contracts.ktg_attorney_wagon_id"),
          sortable: true,
        },
        {
          key: "ktg_wagon_number",
          label: this.$t("message.contracts.ktg_attorney_wagon_number"),
          sortable: true,
        },
        {
          key: "remove",
          label: "",
        },
      ],
      countries: [],
    };
  },
  methods: {
    removeWagon(index) {
      this.ktg_attorney.wagons.splice(index, 1);
    },
    editWagon(wagon, index) {
      this.wagon = wagon;
      this.edit_wagon = true;
      this.currently_editing = index;
      this.$bvModal.show("modal-add-ktg_attorney_wagon");

      // this.edit_wagon = true
      // this.wagon = this.ktg_attorney.wagons[index]
      // this.currently_editing = index
    },
    save_wagon() {
      this.ktg_attorney.wagons[this.currently_editing] = { ...this.wagon };
      this.$bvModal.hide("modal-add-ktg_attorney_wagon");
      this.currently_editing = -1;
      this.edit_wagon = false;
      this.wagon = {
        ktg_wagon_number: "",
      };
    },
    add_wagon() {
      this.wagon.ktg_wagon_id = this.ktg_attorney.wagons.length + 1;
      this.ktg_attorney.wagons.push({ ...this.wagon });
      this.$bvModal.hide("modal-add-ktg_attorney_wagon");
      this.wagon = {
        ktg_wagon_number: "",
      };
    },

    /**
     * get contract XML and sends it to backend along with token from e-mail to sign data
     * after signing it gets the signature code and sends it back to the backend
     * to store signature in document
     */
    sign_with_code_phase2() {
      if (this.sign_with_code_code != "") {
        axios
          .get(
            window.base +
              "/document/LoadLiabilityInsuranceXML?doc_id=" +
              this.document_id,
          )
          .then((response) => {
            var fd = new FormData();
            var xml = response.data.replace(
              '<?xml version="1.0" encoding="utf-16"?>',
              "",
            );
            fd.append("token", this.sign_with_code_code);
            fd.append("data", xml);
            axios
              .post(window.base + "/account/SignData", fd)
              .then((response) => {
                var fd = new FormData();
                fd.append("contract_id", this.document_id);
                fd.append("signature", response.data);
                axios
                  .post(window.base + "/document/AddDocumentSignature", fd)
                  .then(() => {
                    this.loading = false;
                    new Noty({
                      theme: "light",
                      type: "success",
                      text: this.$root.$t("message.message.contract_signed"),
                      timeout: 5000,
                    }).show();
                    this.$bvModal.hide("modal-select-ecp-type-ktg_attorney");
                  })
                  .catch((e) => {
                    this.loading = false;
                    new Noty({
                      theme: "light",
                      type: "error",
                      text: this.$root.$t(
                        "message.message.contract_not_signed",
                      ),
                      timeout: 5000,
                    }).show();
                    this.$bvModal.hide("modal-select-ecp-type-ktg_attorney");
                  });
              });
          });
      }
    },
    /**
     * Sends request to backend to send a code to sign a document without ECP
     */
    sign_with_code() {
      axios
        .get(window.base + "/account/GenerateToken?doc_id=" + this.document_id)
        .then((response) => {
          console.log(response.data);
          this.show_code_sign_type = true;
        });
    },
    /**
     * Initializes electorinc signature for the document.
     * Gets XML from backend.
     * Signs with NCA Layer.
     * Sends signature back to backend to store for future comparison.
     */
    signDocument() {
      this.loading = true;
      axios
        .get(
          window.base +
            "/document/LoadKtgAttorneyXML?doc_id=" +
            this.document_id,
        )
        .then((response) => {
          this.xml = response.data.replace(
            '<?xml version="1.0" encoding="utf-16"?>',
            "",
          );
          window.webSocket = new WebSocket("wss://127.0.0.1:13579/");
          window.callback = null;

          window.webSocket.onopen = (event) => {
            window.signXml("PKCS12", "SIGNATURE", this.xml, () => {});
          };

          window.webSocket.onclose = function (event) {
            if (event.wasClean) {
            } else {
              openDialog();
            }
          };

          window.webSocket.onmessage = (event) => {
            var result = JSON.parse(event.data);
            if (result != null) {
              var rw = {
                code: result["code"],
                message: result["message"],
                responseObject: result["responseObject"],
                getResult: function () {
                  return this.result;
                },
                getMessage: function () {
                  return this.message;
                },
                getResponseObject: function () {
                  return this.responseObject;
                },
                getCode: function () {
                  return this.code;
                },
              };
              if (rw.code == "200") {
                var oParser = new DOMParser();
                var oDOM = oParser.parseFromString(
                  rw.getResponseObject(),
                  "application/xml",
                );
                var value =
                  oDOM.getElementsByTagName("ds:SignatureValue")[0].innerHTML;
                var certificate =
                  oDOM.getElementsByTagName("ds:X509Certificate")[0].innerHTML;

                axios
                  .get(window.base + "/account/loadSignatureDetails")
                  .then((response) => {
                    let cert = response.data.cert.replace(
                      /(?:\r\n|\r|\n)/g,
                      "",
                    );
                    if (cert == certificate.replace(/(?:\r\n|\r|\n)/g, "")) {
                      var fd = new FormData();
                      let name = response.data.cert_name;
                      fd.append("document_id", this.document_id);
                      fd.append("contract_id", this.document_id);
                      fd.append("signature_name", name);
                      fd.append("signature", value);
                      fd.append("type", "signature");
                      axios
                        .post(
                          window.base + "/document/AddDocumentSignature",
                          fd,
                        )
                        .then(() => {
                          this.loading = false;
                          this.load(); //refresh status of the contract
                          new Noty({
                            theme: "light",
                            type: "success",
                            text: this.$t("message.message.document_signed"),
                            timeout: 5000,
                          }).show();
                          this.$bvModal.hide(
                            "modal-select-ecp-type-ktg_attorney",
                          );
                        })
                        .catch((e) => {
                          this.loading = false;
                          new Noty({
                            theme: "light",
                            type: "error",
                            text:
                              this.$t("message.message.document_not_signed") +
                              " (" +
                              e +
                              ")",
                            timeout: 5000,
                          }).show();
                          this.$bvModal.hide(
                            "modal-select-ecp-type-ktg_attorney",
                          );
                        });
                    } else {
                      this.loading = false;
                      new Noty({
                        theme: "light",
                        type: "error",
                        text: this.$t(
                          "message.message.document_not_signed_cert_invalid",
                        ),
                        timeout: 5000,
                      }).show();
                    }
                  });

                // var fd = new FormData;
                // fd.append('contract_id', this.document_id)
                // fd.append('signature', value)
                // axios.post(window.base + '/document/AddDocumentSignature', fd).then(()=>{
                // 	this.loading = false
                // 	new Noty({
                // 		theme: 'light',
                // 		type: 'success',
                // 		text: this.$root.$t('message.message.document_signed'),
                // 		timeout: 5000,
                // 	}).show();
                // 	this.$bvModal.hide('modal-select-ecp-type-invoice')
                // }).catch(e=>{
                // 	this.loading = false
                // 	new Noty({
                // 		theme: 'light',
                // 		type: 'error',
                // 		text: this.$root.$t('message.message.document_not_signed'),
                // 		timeout: 5000,
                // 	}).show();
                // 	this.$bvModal.hide('modal-select-ecp-type-invoice')
                // })
                window.webSocket.close();
                // window.webSocket.removeEventListener('message', {})
              }
            }
          };
        });
    },
    load() {
      axios
        .get(
          window.base + "/Document/LoadKtgAttorney/?doc_id=" + this.document_id,
        )
        .then((response) => {
          this.$emit("file", response.data.files);
          this.ktg_attorney = response.data;
          this.doc_id = response.data.doc_id;
          this.ktg_attorney.wagons.forEach((obj, index) => {
            obj.ktg_wagon_id = index + 1;
          });
        });
    },
    submit_and_sign_dialog() {
      this.$bvModal.show("modal-select-ecp-type-ktg_attorney");
    },
    saveDocument() {
      this.$root.$emit("show-loading");
      this.buttons_loading = true;
      this.ktg_attorney.ktg_doc_date = this.document.attis_contract_doc_date;
      var tmp = this.ktg_attorney;
      tmp.files = this.files;
      var t1 = this.$t("message.error");
      axios
        .post(
          window.base +
            (this.is_new === true
              ? "/Document/CreateKtgAttorney" +
                "?contract_id=" +
                this.$route.params.id
              : "/Document/UpdateKtgAttorney" + "?doc_id=" + this.document_id),
          tmp,
        )
        .then((response) => {
          console.log(response.data);
          if (response.data == "ok") {
            new Noty({
              theme: "light",
              type: "success",
              text: this.$root.$t("message.message.ktg_attorney_created"),
              timeout: 5000,
            }).show();
            this.$root.$emit("loadDocuments", { category: "all" });
            this.$root.$emit("bv::hide::modal", "modal-document", "#btnShow");
            this.$root.$emit(
              "bv::hide::modal",
              "modal-document-new",
              "#btnShow",
            );
            // if(this.is_edit){
            // 	this.$root.$emit('insurance-saved')
            // }
          } else {
            console.info("else case");
            new Noty({
              theme: "light",
              type: "error",
              text:
                this.$root.$t("message.message.ktg_attorney_not_created") +
                " (" +
                response.data +
                ")",
              timeout: 5000,
            }).show();
            if (window.dev_mode) {
              this.$root.$emit("bv::hide::modal", "modal-document", "#btnShow");
              this.$root.$emit(
                "bv::hide::modal",
                "modal-document-new",
                "#btnShow",
              );
            }
          }
        })
        .catch((e) => {
          console.log(e);
          new Noty({
            theme: "light",
            type: "error",
            text: t1,
            timeout: 5000,
          }).show();
          this.$root.$emit("bv::hide::modal", "modal-document", "#btnShow");
          this.$root.$emit("bv::hide::modal", "modal-document-new", "#btnShow");
        });
    },
    fetchCountries(search, loading) {
      this.getLibrary("country", search, 100);
    },
    getLibrary(type, query, qty) {
      query = query.toLowerCase();
      axios
        .get(
          window.base +
            "/library?type=" +
            type +
            "&query=" +
            query +
            "&qty=" +
            qty +
            "&lang=" +
            this.$i18n.locale,
        )
        .then((response) => {
          var var_name = type;
          if (type[type.length - 1] == "s") {
            var_name = type + "es";
          } else if (type[type.length - 1] == "y") {
            var_name = type.substring(0, type.length - 1) + "ies";
          } else {
            var_name = type + "s";
          }
          this.$data[var_name] = [];
          response.data.forEach((item) => {
            if (item.value !== "··········") this.$data[var_name].push(item);
          });
          // this.$data[var_name] = response.data
        });
    },
  },
  mounted() {
    this.fetchCountries("");
    if (this.document_id != "new") {
      this.load();
    } else {
      axios
        .get(window.base + "/document/KtgAttorneyInitialData")
        .then((response) => {
          this.ktg_attorney.ktg_acting_basis = this.$t(
            "message.contracts.ktg_act_basis_placeholder",
          );
          this.ktg_attorney.ktg_principal_name =
            response.data.organizations.org_name;
          this.ktg_attorney.ktg_principal_code =
            response.data.organizations.org_code;
          if (response.data.addresses[0]) {
            let address = [];
            if (response.data.addresses[0].post_addr_country)
              address.push(
                this.countries[
                  this.countries.findIndex(
                    (itm) =>
                      itm.value ==
                      response.data.addresses[0].post_addr_country.trim(),
                  )
                ].display_text,
              );
            if (response.data.addresses[0].post_addr_region)
              address.push(response.data.addresses[0].post_addr_region);
            if (response.data.addresses[0].post_addr_district)
              address.push(response.data.addresses[0].post_addr_district);
            if (response.data.addresses[0].post_addr_town)
              address.push(response.data.addresses[0].post_addr_town);
            if (response.data.addresses[0].post_addr_city)
              address.push(response.data.addresses[0].post_addr_city);
            if (response.data.addresses[0].post_addr_streethouse)
              address.push(response.data.addresses[0].post_addr_streethouse);
            if (response.data.addresses[0].post_addr_house)
              address.push(response.data.addresses[0].post_addr_house);
            if (response.data.addresses[0].post_addr_index)
              address.push(response.data.addresses[0].post_addr_index);
            this.ktg_attorney.ktg_principal_address = address.join(",");
          }
          this.ktg_attorney.ktg_representative_full_name =
            response.data.persons.given_name +
            " " +
            response.data.persons.middle_name +
            " " +
            response.data.persons.last_name;
          this.ktg_attorney.ktg_representative_job_title =
            response.data.persons.position;
        });
    }
  },
  computed: {
    locale() {
      var locale = this.$i18n.locale;
      var _this = this;
      switch (locale) {
        case "cn":
          locale = "zh-CN";
          break;
        case "en":
          locale = "en-US";
          break;
      }
      return locale;
    },
    is_field_readonly() {
      if (this.ktg_attorney.IsSigned || this.readonly) return true;
      return false;
    },
  },
};
</script>
<style>
#rwb_contract_date__outer_ {
  padding: 0 !important;
  height: 36px !important;
}
.b-form-timepicker label {
  background-image: none !important;
  align-self: center;
  padding-top: 6px;
  border: 0 !important;
}
.b-form-timepicker .btn {
  background: #fff !important;
  color: #3c4858;
}
</style>
